export const WelcomePage = {
  ContinueBtn: 'continue-btn',
  JustExploringBtn: 'just-exploring-btn',
  ServiceTilePrefix: 'service-tile',
};
